import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { useRef, useState } from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Input } from '../../../../web/components-v2/Input';
import { Pill } from '../../../../web/components-v2/Pill';
import { styleSheet } from './styles';

interface IProps {
	label: string;
	url: string;
	onFileSelected(file: File): void;
	className?: string;
	styles?: StyleDeclarationValue[];
	/** Comma separated list of file extensions */
	accept?: string;
}

const parseFileName = (url: string) => {
	const slashIndex = url.lastIndexOf('/') + 1;
	const stringAfterSlash = url.substring(slashIndex);
	const queryIndex = stringAfterSlash.indexOf('?');
	const filename = stringAfterSlash.substring(0, queryIndex);
	return filename.substring(0, 20);
};

export const MemeFile: React.FC<IProps> = props => {
	const { label, url, styles = [], className, accept, onFileSelected } = props;
	const inputRef = useRef<HTMLInputElement>(null);
	const [isReuploading, setReuploading] = useState(false);
	const [inputValue, setInputValue] = useState('');

	const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onFileSelected?.(e.currentTarget.files[0]);
		setInputValue(e.currentTarget.value);
		setReuploading(false);
	};

	const onUploadClick = () => {
		inputRef.current?.click();
	};

	const onXClick = () => {
		setInputValue('');
		setReuploading(true);
	};

	return (
		<div className={`${css(styleSheet.container, ...styles)} meme-file ${className || ''}`}>
			<span className={css(styleSheet.label)}>{label}</span>
			{url && !isReuploading ? (
				<Pill variant='tag' color='blue' label={parseFileName(url)} onRemove={onXClick} />
			) : (
				<Button variant='secondary' size='sm' onClick={onUploadClick}>
					Upload
				</Button>
			)}
			<Input
				styles={[styleSheet.fileInput]}
				aria-label={`${label} file`}
				type='file'
				onChange={onFileChange}
				ref={inputRef}
				accept={accept}
				multiple={false}
				value={inputValue}
			/>
		</div>
	);
};
